<template>
  <modal @before-open="beforeOpen" @opened="opened" name="meetingDetailModal" :draggable="'.header'" :reset="true"
         :classes="['meetingDetailModal','generalbox']" :adaptive="true"
          :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false" :pivotX="pivotX" :pivotY="pivotY">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>会议详情</h2>
    </div>
    <div class="content">
      <div v-if="meetingId" class="container">
        <meeting-detail :meetingId="meetingId"></meeting-detail>
      </div>

    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  import meetingDetail from 'components/meeting/meetingDetail'

  
  export default {
    name: "meetingDetailModal",
    data() {
      return {
        meetingId:null,
        pivotX:null,
        pivotY:null
      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("meetingDetailModal");
      },
      beforeOpen(data) {
        this.meetingId=data.params.info.id

        if (data.params.info.stackLayout) {
          this.pivotX = this.modalOffsetDistance.x
          this.pivotY = this.modalOffsetDistance.y
        } else {
          this.pivotX = 0.5
          this.pivotY = 0.5
        }

      },
      opened(){
        this.updateModalZIndex(this.$el)
      },
      
    },
    computed: {
      ...mapState(['modalOffsetDistance']),
    },
    mounted() {
    },
    components: {meetingDetail}
  }
</script>

<style lang="stylus" scoped>

</style>


// WEBPACK FOOTER //
// src/components/meeting/meetingDetailModal.vue